<template >
<!-- <template>{{getEContentDownloadUrl}}</template> -->
  <vue-pdf-app theme="dark"  :config="config2"  :pdf="getEContentDownloadUrl">
    
  </vue-pdf-app>
  
</template>

<script>
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";

export default {
  components: {
    VuePdfApp
  },
  data(){
  	return{
  		 config2: {
        toolbar: {
          toolbarViewerRight: false
        }
      },
  	}
  },
  computed: {
    getEContentDownloadUrl() {
      return this.$store.getters.getEContentDownloadUrl;
    }
   
  },
};
</script>
<style >
  
</style>